import { profile as actions } from '../actions'
import { mergeRight } from 'ramda'

// Reducers for
// store/action-methods/profile.js
export const reducer = {}

reducer[actions.SET_PROFILE] = ({ state, action: { payload } }) =>
  mergeRight(state, payload)
